import { useVariantStore } from '~/stores/variantStore';
import { useRoute, useRouter } from 'vue-router';

export const useClearVariantStore = () => {
  const route = useRoute();
  const router = useRouter();
  const variantStore = useVariantStore();

  // Check if clear-variant-store parameter exists
  if ('clear-store' in route.query) {
    // Clear the store
    variantStore.clear();
    
    // Remove the parameter from URL
    const query = { ...route.query };
    delete query['clear-store'];
    router.replace({ query });
  }
}; 